'use strict';
angular.module('uploadIsiconModule', ['tManageMentServiceModule'])
    .controller('uploadIsiconCtrl', ['$scope', '$modalInstance', 'aspectRatio', '$q', '$timeout', 'params', 'editPictureService', 'trsHttpService', 'modalDialog',
        function($scope, $modalInstance, aspectRatio, $q, $timeout, params, editPictureService, trsHttpService, modalDialog) {
            var $img,
                img, event, options, containerWidth, containerHeight, imgHeight, imgWidth, imgRatio, flag = true;
            initStatus();
            if (typeof define === 'function' && define.amd) { // AMD
                require(['./lib/cropper/cropper.js'], function(echarts) {
                    initData();
                });
            } else {
                LazyLoad.js(['./lib/requirejs/require.js'], function() {
                    require(['./lib/cropper/cropper.js'], function(echarts) {
                        initData();
                    });
                });
            }

            /**
             * [initStatus description]初始化状态
             */
            function initStatus() {
                $scope.status = {
                    imgSrc: params.data.imgSrc,
                    rotate: 0
                };
                $scope.status.logo = params.tenantLogo ? params.tenantLogo : '头像设置';
            }

            function initCropper() {
                var deffer = $q.defer();
                $timeout(function() {
                    $img = $('#img');
                    $scope.status.imgSrc = $scope.status.imgSrc.replace(/ScaleWidth=600&/g, '');
                    if ($scope.status.imgSrc.indexOf('http://') === 0) {
                        var imgArray = $scope.status.imgSrc.split('/');
                        imgArray.splice(0, 3);
                        $scope.status.imgSrc = ('/' + imgArray.join('/')).replace(/ScaleWidth=600&/g, '');
                    }
                    var imgType = editPictureService.getImageType($scope.status.imgSrc);
                    img = new Image();
                    img.src = $scope.status.imgSrc;
                    img.onload = function() {
                        $timeout(function() {
                            $scope.status.orgWidth = img.width;
                            $scope.status.orgHeight = img.height;
                        });
                        $img.attr('src', $scope.status.imgSrc);
                        options = {
                            // aspectRatio: 16 / 9,
                            viewMode: 1,
                            checkCrossOrigin: false,
                            zoomable: true,
                            aspectRatio: aspectRatio ? aspectRatio : 1,
                            zoomOnWheel: false,
                            dragMode: 'none',
                            // movable: true,
                            // aspectRatio: params.pictureSize.width / params.pictureSize.height,
                            cropBoxResizable: true, // 禁止改变裁剪框的大小
                            // aspectRatio: aspectRatio,
                            autoCropArea: 0.1,
                            // cropBoxResizable: false,
                            crop: function(e) {
                                // console.log(e);
                            }
                        };
                        $img.on({
                            'build.cropper': function(e) {
                                // console.log(e.type);
                            },
                            'built.cropper': function(e) {
                                containerWidth = $img.cropper('getContainerData').width;
                                containerHeight = $img.cropper('getContainerData').height;
                                imgWidth = $img.cropper('getImageData').width;
                                imgHeight = $img.cropper('getImageData').height;
                                imgRatio = 1;
                                // $img.cropper("setCropBoxData", {
                                //     left: imgWidth / 4,
                                //     top: imgHeight / 4,
                                //     width: 300,
                                //     height: 300
                                // });

                                $img.cropper('setData', { left: 0, top: 0, width: 300, height: 300 });

                                // console.log(e.type);
                            },
                            'cropstart.cropper': function(e) {
                                flag = true;
                                // console.log(e.type, e.action);
                            },
                            'cropmove.cropper': function(e) {
                                // console.log(e.type, e.action);
                            },
                            'cropend.cropper': function(e) {

                                /* var cropBoxData = $img.cropper("getCropBoxData");
                                var marginLeft = (containerWidth - imgWidth) / 2;
                                var marginTop = (containerHeight - imgHeight) / 2;
                                var left = cropBoxData.left - marginLeft;
                                var top = cropBoxData.top - marginTop;
                                var width = cropBoxData.width / imgRatio;
                                var height = cropBoxData.height / imgRatio;
                                $("#horizontal").val(Math.round(left));
                                $("#vertical").val(Math.round(top));
                                $("#realWidth").val(Math.round(width));
                                $("#realHeight").val(Math.round(height));*/
                                // console.log(e.type, e.action);
                            },
                            'crop.cropper': function(e) {
                                delete $scope.status.previewResult; // 删除上次预览结果
                                $scope.status.event = event = e;
                                previewImgDivStyle(e);
                                if (!flag) {return;}
                                outOfrangeprocess(e);
                                $('#horizontal').val(Math.round(e.x));
                                $('#vertical').val(Math.round(e.y));
                                $('#realWidth').val(Math.round(e.width));
                                $('#realHeight').val(Math.round(e.height));
                            },
                            'zoom.cropper': function(e) {}
                        }).cropper(options);
                        $('#horizontal').bind('change', function() {
                            flag = false;
                            var myValue = parseFloat($(this).val()),
                                width;
                            myValue = myValue > 0 ? myValue : 0;
                            myValue = myValue > $scope.status.orgWidth ? $scope.status.orgWidth : myValue;
                            if ((myValue + event.width) > $scope.status.orgWidth) {
                                width = $scope.status.orgWidth - myValue;
                                $('#realWidth').val(Math.round(width));
                            }
                            $(this).val(myValue);
                            var margin = (containerWidth - imgWidth) / 2;
                            $img.cropper('setCropBoxData', { left: myValue * imgRatio + margin, width: width * imgRatio });
                        });
                        $('#vertical').bind('change', function() {
                            flag = false;
                            var myValue = parseFloat($(this).val()),
                                height;
                            myValue = myValue > 0 ? myValue : 0;
                            myValue = myValue > $scope.status.orgHeight ? $scope.status.orgHeight : myValue;
                            if ((myValue + event.height) > $scope.status.orgHeight) {
                                height = $scope.status.orgHeight - myValue;
                                $('#realHeight').val(Math.round(height));
                            }
                            $(this).val(myValue);
                            var margin = (containerHeight - imgHeight) / 2;
                            $img.cropper('setCropBoxData', { top: myValue * imgRatio + margin, height: height * imgRatio });
                        });
                        $('#realWidth').bind('change', function() {
                            flag = false;
                            var myValue = parseFloat($(this).val());
                            myValue = myValue > 0 ? myValue : 0;
                            myValue = myValue + event.x > $scope.status.orgWidth ? ($scope.status.orgWidth - event.x) : myValue;
                            myValue = Math.round(myValue);
                            $(this).val(myValue);
                            $img.cropper('setCropBoxData', { width: myValue * imgRatio });
                        });
                        $('#realHeight').bind('change', function() {
                            flag = false;
                            var myValue = parseFloat($(this).val());
                            myValue = myValue > 0 ? myValue : 0;
                            myValue = myValue + event.y > $scope.status.orgHeight ? ($scope.status.orgHeight - event.y) : myValue;
                            myValue = Math.round(myValue);
                            $(this).val(myValue);
                            $img.cropper('setCropBoxData', { height: myValue * imgRatio });
                        });
                    };
                    deffer.resolve();
                }, 1000);
                return deffer.promise;
            }

            /**
             * [initData description]初始化数据
             */
            function initData() {
                $scope.loadingPromise = initCropper();
            }

            /**
             * [reset description]重置裁剪
             */
            $scope.reset = function() {
                $scope.status.rotate = 0; // 重置时预览框的角度变为0
                // $img.cropper("reset");
                $scope.status.imgSrc = params.data.imgSrc;
                $scope.loadingPromise = initCropper().then(function() {
                    $img.cropper('replace', $scope.status.imgSrc, false);
                });
            };

            /**
             * [zoom description]按钮缩放
             * @param  {[string]} value [description] 缩放值
             */
            $scope.zoom = function(value) {
                $img.cropper('zoom', parseFloat(value));
            };

            /**
             * [turnPicture description]图片旋转
             * @param  {[string]} value [description] 角度
             */
            $scope.turnPicture = function(value) {
                $scope.loadingPromise = editPictureService.rotateImage(value, $scope.status.imgSrc).then(function(imgName) {
                    $scope.status.imgSrc = '/wcm/openapi/readimg?FileName=' + imgName;
                    initCropper().then(function() {
                        $img.cropper('replace', $scope.status.imgSrc, false);
                    });
                });
            };

            /**
             * [cancel description]取消图片编辑 关闭窗口
             */
            $scope.cancel = function() {
                $modalInstance.dismiss();
            };

            /**
             * [cropper description]裁剪图片 关闭窗口
             */
            $scope.cropper = function() {
                if ($scope.status.previewResult) {
                    $modalInstance.close($scope.status.previewResult);
                    return;
                }
                cropper().then(function(result) {
                    $modalInstance.close(result);
                });
            };

            /**
             * [previewImgDiv description]预览框的样式设定
             */
            function previewImgDivStyle(event) {
                var width, height;
                var imgAspectRatio = event.width / event.height;
                var divAspectRatio = 1;
                if (imgAspectRatio > divAspectRatio) {
                    width = '100px';
                    height = 100 / imgAspectRatio + 'px';
                } else {
                    height = '100px';
                    width = 100 * imgAspectRatio + 'px';
                }
                $scope.status.imgOuterDiv = 'width:' + width + ';height:' + height;
                previewImgStyle(event, width, height);
            }

            /**
             * [previewImgDiv description]预览框的图片样式设定
             */
            function previewImgStyle(event, preDivWidth, preDivHeight) {
                preDivWidth = parseFloat(preDivWidth.replace(/px/, ''));
                preDivHeight = parseFloat(preDivHeight.replace(/px/, ''));
                var cropRadio, preImgWidth, preImgHeight, zoomRadio, preTop, preLeft;
                var imgAspectRatio = $scope.status.orgWidth / $scope.status.orgHeight;
                if (Math.abs(event.rotate) === 90 || Math.abs(event.rotate) === 270) {
                    cropRadio = event.width / $scope.status.orgHeight;
                    preImgWidth = (preDivWidth / cropRadio) * imgAspectRatio;
                    preImgHeight = preImgWidth / imgAspectRatio;
                    zoomRadio = preImgWidth / $scope.status.orgWidth;
                    preTop = (-event.y * zoomRadio) - (preImgHeight - preImgWidth) / 2 + 'px';
                    preLeft = (-event.x * zoomRadio) + (preImgHeight - preImgWidth) / 2 + 'px';
                } else {
                    cropRadio = event.width / $scope.status.orgWidth;
                    preImgWidth = (preDivWidth / cropRadio);
                    zoomRadio = preImgWidth / $scope.status.orgWidth;
                    preTop = (-event.y * zoomRadio) + 'px';
                    preLeft = (-event.x * zoomRadio) + 'px';
                }
                $timeout(function() {
                    $scope.status.imgStyle = 'width:' + preImgWidth + 'px;top:' + preTop + ';left:' + preLeft + ';transform:rotate(' + $scope.status.rotate + 'deg)';
                });
                $scope.chicunW = Math.round(event.width);
                $scope.chicunH = Math.round(event.height);
            }

            /**
             * [cropper description]裁剪接口
             */
            function cropper() {
                var deffer = $q.defer();
                var params = {
                    serviceid: 'mlf_image',
                    methodname: 'cropimage',
                    FILENAME: editPictureService.getFileName($scope.status.imgSrc),
                    X: Math.round(event.x),
                    Y: Math.round(event.y),
                    WIDTH: Math.round(event.width),
                    HEIGHT: Math.round(event.height)
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    var result = {
                        imgName: data.FN,
                        imgSrc: '/wcm/file/read_image.jsp?FileName=' + data.FN,
                        success: '上传成功'
                    };
                    deffer.resolve(result);
                });
                return deffer.promise;
            }

            /**
             * [outOfrangeprocess description]裁剪框超出范围处理
             */
            var promise;

            function outOfrangeprocess(e) {
                if (promise) {
                    $timeout.cancel(promise);
                    promise = null;
                }
                promise = $timeout(function() {
                    if (promise) {
                        $timeout.cancel(promise);
                        promise = null;
                    }
                    var marginTop = (containerHeight - imgHeight) / 2;
                    var marginLeft = (containerWidth - imgWidth) / 2;
                    if (e.x < 0) {
                        $img.cropper('setCropBoxData', { left: marginLeft });
                        $('#horizontal').val(0);
                    }
                    if (e.y < 0) {
                        $img.cropper('setCropBoxData', { top: marginTop });
                        $('#vertical').val(0);
                    }
                    if (e.x > $scope.status.orgWidth) {
                        $img.cropper('setCropBoxData', { left: $scope.status.orgWidth * imgRatio + marginLeft });
                        $('#realWidth').val($scope.status.orgWidth);
                    }
                    if ((e.x + e.width) > $scope.status.orgWidth) {
                        var fixWidth = ($scope.status.orgWidth - e.x) * imgRatio;
                        $img.cropper('setCropBoxData', { width: fixWidth });
                    }
                    if (e.y > $scope.status.orgHeight) {
                        $img.cropper('setCropBoxData', { top: $scope.status.orgHeight * imgRatio + marginTop });
                        $('#realHeight').val($scope.status.orgHeight);
                    }
                    if ((e.y + e.height) > $scope.status.orgHeight) {
                        var fixHeight = ($scope.status.orgHeight - e.y) * imgRatio;
                        $img.cropper('setCropBoxData', { height: '300px' });
                    }
                }, 0.00001);
                return promise;
            }
        }
    ]);
